import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import { IssueGroup, type IssueGroupProps } from "../MenuGroups/IssueGroup"

interface IssueDropdownMenuProps
	extends
		IssueGroupProps,
		Omit<MenuRootProps, "children">,
		Omit<MenuClickTriggerProps, "children" | "ref">,
		MenuVariantProps {
	children: ReactElement
}

export const IssueDropdownMenu = memo((props: IssueDropdownMenuProps) => {
	const { children, issues, onSelectIssue, disabled, size, variant, radius, accentColor, ...rest } = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} variant={variant} accentColor={accentColor} radius={radius}>
				<Menu.Scroll>
					<IssueGroup issues={issues} onSelectIssue={onSelectIssue} />
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
IssueDropdownMenu.displayName = "IssueDropdownMenu"
